<template>
  <div>
    <h5 class="mt-2">
      {{ 'HISTORY_OVERVIEW' | translate }}
    </h5>
    <div v-if="!error" class="table-responsive mt-4">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>{{ 'VERSION' | translate }}</th>
            <th>{{ 'USER_LAST_MODIFIED' | translate }}</th>
            <th>{{ 'DATE_LAST_MODIFIED' | translate }}</th>
            <th>{{ 'LOGS' | translate }}</th>
          </tr>
        </thead>
        <tbody v-if="historyPolicycases.length > 0 && !loading">
          <template v-for="(historyPolicycase, index) in historyPolicycases">
            <!-- Table Row -->
            <tr :key="index" @click="toggleDropdown(index, historyPolicycase.id)" class="clickable-row">
              <td>
                <button type="button"
                        class="btn btn-link"
                        v-on:click.stop="redirectToCase(historyPolicycase.id, index === historyPolicycases.length - 1)">
                  {{ index + 1 }}
                </button>
                <span v-if="index === historyPolicycases.length - 1" class="badge badge-info">
                  {{ 'ACTIVE' | translate }}
                </span>
              </td>
              <td>{{ historyPolicycase.lastUser }}</td>
              <td>{{ historyPolicycase.lastUpdated }}</td>
              <td class="text-center">
                <i class="fa" :class="dropdownOpen === index ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </td>
            </tr>

            <!-- Dropdown Row -->
<tr v-if="dropdownOpen === index" class="dropdown-row">
  <td colspan="4">
    <template v-if="apiLogs.data && apiLogs.data.length > 0">
      <table class="dropdown-inner-table">
        <tbody>
          <tr v-for="apiLog in apiLogs.data" :key="apiLog.id">
            <td>{{ apiLog.source }}</td>
            <td>{{ apiLog.createdAt }}</td>
            <td>
              <button v-if="!['Recalculate', 'ACCEPTED', 'ACCEPTED_MANUALLY', 'CLOSED'].includes(apiLog.source)" type="button" class="btn btn-primary icon-button" @click.stop="downloadApiLog(historyPolicycase.id, apiLog.id, apiLog.source)">
                <span class="btn-icon" id="policyCaseButton-btn-icon"><i class="fa fa-download" aria-hidden="true" id="policyCaseButton-download-vpi-data"></i></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <div class="no-logs">No PolicyCase API Log Found.</div>
    </template>
  </td>
</tr>

          </template>
        </tbody>
      </table>
    </div>
    <div v-else class="alert alert-danger mt-4">{{ error | translate('msg') }}</div>
    <div v-if="historyPolicycases.length <= 0 && !loading" class="text-center mt-4">
      {{ 'LIST_HISTORY_OVERVIEW_EMPTY' | translate('msg') }}
    </div>
    <div v-if="loading" class="text-center mt-4">
      <i class="fa fa-refresh fa-spin fa-2x"></i>
    </div>
  </div>
</template>

<script>

import RestService from '../service/RestService';
export default {
  props: ['historyPolicycases', 'loading', 'error', 'policycaseHeaderId'],
  data() {
    return {
      rest: this.initRestService(),
      dropdownOpen: null,
      apiLogs: [] // Tracks which row's dropdown is open
    };
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    redirectToCase(caseId, isActivePolicycase) {
      if (isActivePolicycase) {
        this.$router.push('/case/' + this.policycaseHeaderId);
      } else {
        this.$router.push('/case/' + this.policycaseHeaderId + '/' + caseId);
      }
      this.$emit('hide-history-overview');
    },
    toggleDropdown(index, policyCaseId) {
      this.loadApiLog(policyCaseId);
      this.dropdownOpen = this.dropdownOpen === index ? null : index; // Toggle dropdown visibility
    },
    async loadApiLog(policyCaseId) {
      this.apiLogs = await this.rest.getApiLog(policyCaseId);
    },
    async downloadApiLog(policyCaseId, policyCaseApiLogId, type) {
      try {
        await this.rest.downloadApiLog(policyCaseId, policyCaseApiLogId).then((response) => {
          // Create a Blob from the response data with text/plain MIME type
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: 'text/plain' })
          );

          // Create a download link
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', policyCaseId + type + '.txt'); // Set filename with .txt extension
          document.body.appendChild(link); // Append to the DOM
          link.click(); // Trigger download
          document.body.removeChild(link); // Remove from the DOM
          window.URL.revokeObjectURL(url); // Free up memory
        });
      } catch (error) {
        this.setError('ERROR_DURING_OPERATION');
        this.$log.error(error.response.data);
      }
    }
  }
}
</script>

<style scoped>
.clickable-row {
  cursor: pointer;
}

.dropdown-icon {
  cursor: pointer;
  font-size: 16px;
}

/* Dropdown row styles */
.dropdown-row {
  background-color: #f8f9fa;
}

.dropdown-row td {
  padding: 0;
  border-top: none;
}

/* Dropdown table inside dropdown row */
.dropdown-inner-table {
  width: 100%;
  margin: 0;
  border-collapse: collapse;
}

.dropdown-inner-table td,
.dropdown-inner-table th {
  padding: 10px;
  font-size: 14px;
}

/* Log button style */
.btn-log {
  padding: 5px 12px;
  font-size: 13px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
}

.btn-log:hover {
  background-color: #0056b3;
}

/* Fallback message */
.no-logs {
  padding: 15px;
  text-align: center;
  color: #666;
  font-style: italic;
}
.icon-button{
  height: 45px;
  width: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/HistoryOverview.vue